import React from "react";
import { connect } from "react-redux";
import { Input, Select } from "../../Input";
import { Button } from "../../Button";
import language from "../../../language";
import axios from "axios";
import toastMessage from "../../../utils/toastMessage";
import icons from "../../../constants/icons";
import { getStorage } from "../../../utils/storage";
import {
  getCells,
  getDistricts,
  getProvinces,
  getSectors,
  getVillages,
} from "../../../utils/rwanda";
import { Separator } from "../../Separator";
import nationalities from "../../../constants/nationalities";
import bloodGroups from "../../../constants/bloodGroups";
import { fetchNIDAInfo } from "../../../utils/queries/nidaQuery";
import moment from "moment";
import UserImg from "../../../assets/userPhotoPlaceholder.png";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

class NewPatient extends React.Component {
  identityDocNumberTypeOptions = () => [
    {
      label: language[this.props.defaultLanguage].rwanda_national_id,
      value: "nationalIDNumber",
      search: "NIDA",
    },
    {
      label: language[this.props.defaultLanguage].no_document,
      value: "noDocument",
    },
  ];

  state = {
    requesterName: "",
    requesterPosition: "",
    error: {},
    isSubmitting: false,
    firstName: "",
    lastName: "",
    contact: "",
    identityNumber: "",
    identityNumberTypes: [],
    dob: "",
    fatherName: "",
    motherName: "",
    placeOfBirth: "",
    user: {},
    identityDocNumberType: null,
    isNidaAutofilled: false,
    imageUrl: "",
    bloodGroup: null,
  
    cell: null,
    district: null,
    gender: null,
    nationality: null,
    patientId: "",
    province: null,
    sector: null,
    village: null,
};

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });

    if (this.props._id) {
      this.setState({
        ...this.props,
        province: this.props.province
          ? {
              label: this.props.province,
              value: this.props.province,
            }
          : null,
        district: this.props.district
          ? {
              label: this.props.district,
              value: this.props.district,
            }
          : null,
        sector: this.props.sector
          ? {
              label: this.props.sector,
              value: this.props.sector,
            }
          : null,
        cell: this.props.cell
          ? {
              label: this.props.cell,
              value: this.props.cell,
            }
          : null,
        village: this.props.village
          ? {
              label: this.props.village,
              value: this.props.village,
            }
          : null,
        nationality: this.props.nationality
          ? {
              label: this.props.nationality,
              value: this.props.nationality,
            }
          : null,
        gender: this.props.gender
          ? {
              label: this.props.gender,
              value: this.props.gender,
            }
          : null,
        placeOfBirth: this.props.placeOfBirth || "",
        identityDocNumberType: this.props.identityDocNumberType
          ? this.identityDocNumberTypeOptions().find(
              (el) => el.value === this.props.identityDocNumberType,
            ) || null
          : this.identityDocNumberTypeOptions().find(
              (el) => el.value === "noDocument",
            ),
        bloodGroup: this.props.bloodGroup
          ? bloodGroups.find((el) => el.value === this.props.bloodGroup) || null
          : null,
      });
    } else {
      this.setState({
        identityDocNumberType: this.identityDocNumberTypeOptions().find(
          (el) => el.value === "noDocument",
        ),
        imageUrl: this.props.imageUrl || "",
      });
    }
  };

  onChangeText = async (field, e) => {
    let { error } = this.state;
    let inputValue = e && e?.target ? e?.target?.value : e;

    delete error[field];

    await this.setState({
      [field]: inputValue,
      error,
    });

    if (
      field === "identityDocNumberType" &&
      inputValue?.value === "noDocument"
    ) {
      this.setState({
        identityNumber: "",
        isNidaAutofilled: false,
        imageUrl: "",
      });
    }

    if (field === "identityNumber") {
      this.setState({
        isNidaAutofilled: false,
      });
    }
  };

  validateForm() {
    let {
      firstName,
      lastName,
      error,
      identityNumber,
      patientId,
// eslint-disable-next-line no-unused-vars
      nationality,
// eslint-disable-next-line no-unused-vars
      fatherName,
// eslint-disable-next-line no-unused-vars
      motherName,
      dob,
      gender,
      identityDocNumberType,
    } = this.state;

    if (firstName === "") {
      error.firstName =
        language[this.props.defaultLanguage].first_name_required;
    }

    if (lastName === "") {
      error.lastName = language[this.props.defaultLanguage].last_name_required;
    }

    if (dob === "") {
      error.dob = language[this.props.defaultLanguage].dob_required;
    }

    if (!gender) {
      error.gender = language[this.props.defaultLanguage].gender_required;
    }

    if (!patientId || patientId === "") {
      error.patientId =
        language[this.props.defaultLanguage].patient_id_required;
    }

    if (!identityDocNumberType) {
      error.identityDocNumberType =
        language[this.props.defaultLanguage].identityDocNumberType_required;
    }

    if (
      identityDocNumberType?.value === "nationalIDNumber" &&
      (!identityNumber || `${identityNumber}`.trim().length !== 16)
    ) {
      error.identityNumber =
        language[this.props.defaultLanguage].invalid_national_id_number;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      let {
          firstName,
          lastName,
          contact,
          identityNumber,
          province,
          district,
          cell,
          village,
          sector,
          patientId,
          nationality,
          dob,
          gender,
          fatherName = "",
          motherName = "",
          placeOfBirth = "",
          identityDocNumberType,
          imageUrl,
          bloodGroup,
        } = this.state,
        url = `${API_URL}/patient`,
        { _id } = this.props,
        method = "POST",
        user = await getStorage();

      let requestedBody = {
        firstName,
        lastName,
        contact,
        identityNumber,
        identityDocNumberType: identityDocNumberType?.value || "noDocument",
        imageUrl,
        addedBy: user.id,
        province: province?.value,
        district: district?.value,
        cell: cell?.value,
        village: village?.value,
        sector: sector?.value,
        patientId: patientId + "",
        nationality: nationality?.value,
        dob,
        gender: gender.value,
        fatherName,
        motherName,
        placeOfBirth,
        bloodGroup: bloodGroup?.value || undefined,
        status: "active",
      };

      if (_id && _id !== "") {
        method = "PUT";
        requestedBody.id = _id;
      }

      const options = {
        method,
        url,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
        data: requestedBody,
      };

      try {
        await axios(options);

        this.setState({
          isSubmitting: false,
        });

        toastMessage(
          "success",
          language[this.props.defaultLanguage][
            method === "PUT" ? "update_data_success" : "add_data_success"
          ],
        );

        this.props.getData(true);
        this.props.handleCloseModal();
      } catch (error) {
        toastMessage("error", error);
        this.setState({ isSubmitting: false });
      }
    }
  };

  handleFetchNIDAInfo = async () => {
    try {
      const { identityDocNumberType, identityNumber, error } = this.state;

      if (identityDocNumberType?.value !== "nationalIDNumber") return;

      if (!identityNumber || `${identityNumber}`.trim().length !== 16) {
        error.identityNumber =
          language[this.props.defaultLanguage].invalid_national_id_number;
        this.setState({ error });
        return;
      }

      this.setState({ isFetchingNIDAInfo: true });

      const data = await fetchNIDAInfo(this.props.defaultLanguage, {
        documentNumber: identityNumber,
      });

      this.setState({ isFetchingNIDAInfo: false });

      if (!data?.documentNumber) {
        return toastMessage("error", data?.message || "NIDA not found");
      }

      const gender = data.sex === "M" ? "male" : "female";
      const normalizedDocumentNumber =
        `${data.documentNumber || identityNumber}`.replace(/\s+/g, "").trim();
      const momentObj = moment(data.dateOfBirth, "DD/MM/YYYY");
      const isRwandan =
        `${data.nationality || ""}`.toUpperCase() === "RW" ||
        `${data.birthCountry || ""}`.toLowerCase() === "rwanda" ||
        `${data.countryOfDomicile || ""}`.toLowerCase() === "rwanda";

      this.setState({
        dateOfBirth: data.dateOfBirth,
        firstName: data.foreName || "",
        lastName: data.surnames || "",
        identityNumber: normalizedDocumentNumber,
        dob: moment(momentObj).format("YYYY-MM-DD"),
        gender: {
          label: gender === "male" ? "Male" : "Female",
          value: gender,
        },
        fatherName: data.fatherNames || "",
        motherName: data.motherNames || "",
        placeOfBirth: data.placeOfBirth || "",
        province: data.province
          ? {
              label: data.province,
              value: data.province,
            }
          : null,
        district: data.district
          ? {
              label: data.district,
              value: data.district,
            }
          : null,
        sector: data.sector
          ? {
              label: data.sector,
              value: data.sector,
            }
          : null,
        cell: data.cell
          ? {
              label: data.cell,
              value: data.cell,
            }
          : null,
        village: data.village
          ? {
              label: data.village,
              value: data.village,
            }
          : null,
        nationality: isRwandan
          ? nationalities.find(
              (el) => `${el.value}`.toLowerCase() === "rwandan",
            )
          : nationalities.find(
              (el) => `${el.value}`.toLowerCase() === "foreign",
            ),
        imageUrl: data.photo || "",
        isNidaAutofilled: true,
      });
    } catch (error) {
      this.setState({ isFetchingNIDAInfo: false });
      toastMessage("error", error);
    }
  };

  render() {
    return (
      <div>
        <div className="card-body">
          {this.state.imageUrl && (
            <center style={{ paddingBottom: "1rem" }}>
              <div className="donor-profile-image-container">
                <img
                  alt=""
                  src={`data:image/jpeg;base64,${this.state.imageUrl}`}
                  onError={(e) => {
                    e.currentTarget.src = UserImg;
                  }}
                />
              </div>
            </center>
          )}
          <div className="row">
            <div className="col-md-6">
              <Select
                options={this.identityDocNumberTypeOptions()}
                label={
                  language[this.props.defaultLanguage].identityDocNumberType
                }
                value={this.state.identityDocNumberType}
                onChange={(e) => this.onChangeText("identityDocNumberType", e)}
                error={this.state.error.identityDocNumberType}
                required
              />
            </div>
            {this.state.identityDocNumberType?.value !== "noDocument" && (
              <div className="col-md-6">
                <Input
                  leftIcon={icons.identification}
                  placeholder={
                    language[this.props.defaultLanguage]
                      .identity_number_placeholder
                  }
                  label={language[this.props.defaultLanguage].identity_number}
                  value={this.state.identityNumber}
                  onChange={(e) => this.onChangeText("identityNumber", e)}
                  error={this.state.error.identityNumber}
                  maxLength={16}
                  type="text"
                  rightButtonIcon={
                    this.state.identityDocNumberType?.search === "NIDA" &&
                    icons.search
                  }
                  rightButtonPressed={() =>
                    this.state.identityDocNumberType?.search === "NIDA"
                      ? this.handleFetchNIDAInfo()
                      : null
                  }
                  rightButtonSubmitting={this.state.isFetchingNIDAInfo}
                />
              </div>
            )}

            <Separator title={language[this.props.defaultLanguage].patient} />

            <div className="col-md-4">
              <Input
                leftIcon={icons.user}
                placeholder={
                  language[this.props.defaultLanguage].patient_id_placeholder
                }
                label={language[this.props.defaultLanguage].patient_id}
                required
                value={this.state.patientId}
                onChange={(e) => this.onChangeText("patientId", e)}
                error={this.state.error.patientId}
              />
            </div>
            <div className="col-md-4">
              <Input
                leftIcon={icons.user}
                placeholder={
                  language[this.props.defaultLanguage].first_name_placeholder
                }
                label={language[this.props.defaultLanguage].first_name}
                required
                value={this.state.firstName}
                onChange={(e) => this.onChangeText("firstName", e)}
                error={this.state.error.firstName}
                disabled={this.state.isNidaAutofilled}
              />
            </div>
            <div className="col-md-4">
              <Input
                leftIcon={icons.user}
                placeholder={
                  language[this.props.defaultLanguage].last_name_placeholder
                }
                label={language[this.props.defaultLanguage].last_name}
                required
                value={this.state.lastName}
                onChange={(e) => this.onChangeText("lastName", e)}
                error={this.state.error.lastName}
                disabled={this.state.isNidaAutofilled}
              />
            </div>
            <div className="col-md-4">
              <Input
                label={language[this.props.defaultLanguage].date_of_birth}
                required
                value={this.state.dob}
                onChange={(e) => this.onChangeText("dob", e)}
                error={this.state.error.dob}
                type="date"
                max={new Date().toISOString().split("T")[0]}
                disabled={this.state.isNidaAutofilled}
              />
            </div>
            <div className="col-md-4">
              <Select
                options={[
                  {
                    label: "Male",
                    value: "male",
                  },
                  {
                    label: "Female",
                    value: "female",
                  },
                ]}
                label={language[this.props.defaultLanguage].gender}
                required
                value={this.state.gender}
                onChange={(e) => this.onChangeText("gender", e)}
                error={this.state.error.gender}
                disabled={this.state.isNidaAutofilled}
              />
            </div>
            <div className="col-md-4">
              <Input
                leftIcon={icons.phone}
                placeholder={
                  language[this.props.defaultLanguage].contact_placeholder
                }
                label={language[this.props.defaultLanguage].contact}
                value={this.state.contact}
                onChange={(e) => this.onChangeText("contact", e)}
                error={this.state.error.contact}
              />
            </div>

            <div className="col-md-4">
              <Select
                options={nationalities}
                label={language[this.props.defaultLanguage].nationality}
                value={this.state.nationality}
                onChange={(e) => this.onChangeText("nationality", e)}
                error={this.state.error.nationality}
                disabled={this.state.isNidaAutofilled}
              />
            </div>
            <div className="col-md-4">
              <Select
                options={bloodGroups}
                label="Blood Group"
                placeholder="Select blood group"
                value={this.state.bloodGroup}
                onChange={(e) => this.onChangeText("bloodGroup", e)}
                error={this.state.error.bloodGroup}
              />
            </div>

            <Separator
              title={`${language[this.props.defaultLanguage].father_name} / ${language[this.props.defaultLanguage].mother_name}`}
            />

            <div className="col-md-4">
              <Input
                leftIcon={icons.user}
                placeholder={
                  language[this.props.defaultLanguage].father_name_placeholder
                }
                label={language[this.props.defaultLanguage].father_name}
                // required
                value={this.state.fatherName}
                onChange={(e) => this.onChangeText("fatherName", e)}
                error={this.state.error.fatherName}
                disabled={this.state.isNidaAutofilled}
              />
            </div>
            <div className="col-md-4">
              <Input
                leftIcon={icons.user}
                placeholder={
                  language[this.props.defaultLanguage].mother_name_placeholder
                }
                label={language[this.props.defaultLanguage].mother_name}
                // required
                value={this.state.motherName}
                onChange={(e) => this.onChangeText("motherName", e)}
                error={this.state.error.motherName}
                disabled={this.state.isNidaAutofilled}
              />
            </div>
            <div className="col-md-4">
              <Input
                leftIcon={icons.user}
                placeholder={
                  language[this.props.defaultLanguage].place_of_birth
                }
                label={language[this.props.defaultLanguage].place_of_birth}
                value={this.state.placeOfBirth}
                onChange={(e) => this.onChangeText("placeOfBirth", e)}
                error={this.state.error.placeOfBirth}
                disabled={this.state.isNidaAutofilled}
              />
            </div>
            <Separator
              title={language[this.props.defaultLanguage].residential_address}
            />
            <div className="col-md-4">
              <Select
                options={getProvinces(this.state.province)}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].province}
                value={this.state.province}
                onChange={(e) => this.onChangeText("province", e)}
                error={this.state.error.province}
              />
            </div>
            <div className="col-md-4">
              <Select
                options={getDistricts(this.state.province?.value)}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].district}
                value={this.state.district}
                onChange={(e) => this.onChangeText("district", e)}
                error={this.state.error.district}
              />
            </div>
            <div className="col-md-4">
              <Select
                options={getSectors(
                  this.state.province?.value,
                  this.state.district?.value,
                )}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].sector}
                value={this.state.sector}
                onChange={(e) => this.onChangeText("sector", e)}
                error={this.state.error.sector}
              />
            </div>
            <div className="col-md-4">
              <Select
                options={getCells(
                  this.state.province?.value,
                  this.state.district?.value,
                  this.state.sector?.value,
                )}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].cell}
                value={this.state.cell}
                onChange={(e) => this.onChangeText("cell", e)}
                error={this.state.error.cell}
              />
            </div>
            <div className="col-md-4">
              <Select
                options={getVillages(
                  this.state.province?.value,
                  this.state.district?.value,
                  this.state.sector?.value,
                  this.state.cell?.value,
                )}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].village}
                value={this.state.village}
                onChange={(e) => this.onChangeText("village", e)}
                error={this.state.error.village}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
            className="btn-default"
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            onPress={this.onSubmit.bind(this)}
            isSubmitting={this.state.isSubmitting}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewPatient);
